import * as BBApi from '.';

const rootUrl: string = BBApi.host + '/auth';

export async function signin(email: string, password: string): Promise<void> {
	const body = { email: email.toLowerCase(), password };
	const response: Response = await BBApi.post(rootUrl, body);

	if (response.ok === false) {
		throw new Error('Not authorized');
	}

	const json: any = await response.json();
	// todo: save access token in cookies instead of local localStorage !!!
	localStorage.setItem('bb_token', json.token);
	localStorage.setItem('bb_authorized_routes', JSON.stringify(json.authorizedRoutes));
	localStorage.setItem('bb_rk_access', JSON.stringify(json.rkAccess));
	localStorage.setItem('bb_user_id', json.userId);
}

export async function signout(): Promise<void> {
	await BBApi.del(rootUrl);
	clearAuthStorage();
	// todo: delete access token from cookies
}

export function clearAuthStorage() {
	const email: String|null = localStorage.getItem('bb_email')
	localStorage.clear()
	if (email !== null) {
		localStorage.setItem('bb_email', String(email))
	}
}

export async function getAuthorization(): Promise<void> {
	const response: Response = await BBApi.get(rootUrl);

	if (response.ok === false) {
		throw new Error('Not authorized');
	}

	const json: any = await response.json();
	// todo: save access token in cookies instead of local localStorage !!!
	localStorage.setItem('bb_token', json.token);
	localStorage.setItem('bb_rk_access', JSON.stringify(json.rkAccess));
	localStorage.setItem('bb_authorized_routes', JSON.stringify(json.authorizedRoutes));
}
